// @ts-check

/**
 * Copy telephone text to clipboard when clicking the icon
 */
export function copyTelephoneText(copyText, copiedText) {  
    // 1. Find all elements with the target class
    const targets = document.querySelectorAll('p.text-telephone');

    targets.forEach(textElement => {
        // Prevent adding the icon multiple times
        if (textElement.querySelector('.copy-icon-wrapper')) {
            return;
        }

        // 2. Create the icon and wrapper element
        const iconWrapper = document.createElement('span');
        iconWrapper.className = 'copy-icon-wrapper';
        iconWrapper.title = copyText;

        // SVG for the copy icon.
        iconWrapper.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M23 1V16H16V23H1V8H8V1H23ZM3 10V21H14V10H3ZM10 8H16V14H21V3H10V8Z" fill="#002EA2"/>
            </svg>
        `;

        // 3. Append the icon to the end of the text element
        textElement.appendChild(iconWrapper);

        // 4. Attach the click event listener
        iconWrapper.addEventListener('click', (event) => {
            event.stopPropagation();

            // Get the text content, trim any extra whitespace
            const contentToCopy = textElement.textContent.trim();

            // Exclude the icon's title text from the content (important!)
            const actualText = contentToCopy.replace(copyText, '').trim();

            // Use the Clipboard API
            navigator.clipboard.writeText(actualText)
                .then(() => {
                    // Provide visual feedback 
                    const originalHTML = iconWrapper.innerHTML;
                    iconWrapper.innerHTML = copiedText; 
                    setTimeout(() => {
                        iconWrapper.innerHTML = originalHTML;
                    }, 1500);
                })
                .catch(err => {
                    // Fail silently
                    //alert('Copy failed. Please try manually.');
                });
        });
    });
}
